import React, { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuthGuard } from '../../hooks/useAuthGuard.ts';
import { ROUTE_NAME_OPTIONS } from '../../utils/constants.ts';
import Loading from '../loading/Loading.tsx';

interface AdminRouteProps {
  children: ReactNode;
}

const AdminRoute: React.FC<AdminRouteProps> = ({ children }) => {
  const { isAuthenticated, isAdmin, isLoading } = useAuthGuard();

  if (isLoading) {
    return <Loading fullScreen={true} />;
  }

  if (!isAuthenticated) {
    return <Navigate to={`/${ROUTE_NAME_OPTIONS.LOGIN}`} replace />;
  }

  if (!isAdmin) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
};

export default AdminRoute;
